import React, { useEffect, useState } from "react";

import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { postData } from "../utils/service";
import { URL_API_BANNERS } from "../utils/constants";
import { BannerSkeleton } from "./HomeSkeletons";
import FallbackImage from "./FallbackImage";
import defaultBanner from "../assets/images/default_image.svg";

const SlideBanner = () => {
  const [dataBannerHome, setDataBannerHome] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    postData(URL_API_BANNERS, { is_show: true })
      .then((res) => {
        const updateData =
          res?.data?.data
            ?.filter((item) => item.type === "HOME_PAGE")
            ?.sort((a, b) => a.position - b.position) || [];
        setDataBannerHome(updateData);
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <BannerSkeleton />;
  }

  return (
    <div className="slide_banner">
      {dataBannerHome?.length > 0 && (
        <Carousel
          autoplay
          arrows={true}
          pauseOnHover={false}
          prevArrow={<LeftOutlined />}
          nextArrow={<RightOutlined />}
          autoplaySpeed={10000}
        >
          {dataBannerHome?.map((item) => (
            <div id="section-banner" key={item?.id}>
              <FallbackImage
                variant="banner"
                paths={[
                  isMobile ? item?.image_mobile : item?.image,
                  item?.image,
                  item?.image_mobile,
                ]}
                fallback={defaultBanner}
                alt={item?.title || ""}
              />
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};
export default SlideBanner;
